/**
 * Returns inner Width value for a specific container
 */
export default function getInnerWidth(item: HTMLElement): number {
    return item ? item.clientWidth : 0;
}
